"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var config_provider_1 = require("./../../config-provider");
var icon_1 = __importDefault(require("./../../icon"));
var Common_1 = __importDefault(require("./../Common"));
var utils_1 = require("./../utils");
var TreeNode_1 = __importDefault(require("./TreeNode"));
var TreeOrigin = /** @class */ (function (_super) {
    __extends(TreeOrigin, _super);
    function TreeOrigin(props, context) {
        var _this = _super.call(this, props) || this;
        /**
         * 清空操作
         */
        _this.clear = function () {
            var _a, _b, _c;
            _this.setState({
                mainKeys: [],
            });
            (0, utils_1.checkChildren)(_this.state.data.children, false);
            (0, utils_1.checkParent)(_this.state.data.parent, false);
            (_b = (_a = _this.props) === null || _a === void 0 ? void 0 : _a.onCallback) === null || _b === void 0 ? void 0 : _b.call(_a, (_c = (0, utils_1.filter)(_this.state.data)) === null || _c === void 0 ? void 0 : _c.result);
        };
        /**
         * 选中key
         * @param key
         */
        _this.onCheck = function (key) {
            var _a, _b, _c;
            (0, utils_1.onCheck)(_this.KeyToNodeMapWide, key);
            _this.setState({ data: _this.state.data });
            (_b = (_a = _this.props).onCallback) === null || _b === void 0 ? void 0 : _b.call(_a, (_c = (0, utils_1.filter)(_this.state.data)) === null || _c === void 0 ? void 0 : _c.result);
        };
        _this.KeyToNodeMapWide = {};
        _this.context = context;
        var data = _this.props.data;
        var mainKeys = [];
        var changeData = (0, utils_1.filterRootData)(data, mainKeys);
        _this.state = {
            data: changeData,
            fromNode: undefined,
            mainKeys: mainKeys,
            showListStatus: false,
        };
        return _this;
    }
    TreeOrigin.prototype.componentDidMount = function () {
        var _this = this;
        (0, utils_1.buildKeyMap)(this.state.data, function (data, KeyToNodeMapWide) {
            _this.KeyToNodeMapWide = KeyToNodeMapWide;
            _this.setState({ data: data });
        });
    };
    TreeOrigin.prototype.render = function () {
        var _this = this;
        var _a = this.context.classPrefix, classPrefix = _a === void 0 ? 'intl' : _a;
        var _b = this.props, style = _b.style, className = _b.className, clearText = _b.clearText, titleText = _b.titleText, showText = _b.showText, showLessText = _b.showLessText;
        var _c = this.state, data = _c.data, showListStatus = _c.showListStatus;
        var children = (data || {}).children;
        var childLen = children && children.length > 5;
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)("".concat(classPrefix, "__tree-sizer ").concat(classPrefix, "__tree--wide"), className), style: style },
            react_1.default.createElement("div", { className: "wide-container  ".concat(classPrefix, "__tree--common") },
                react_1.default.createElement(Common_1.default, { action: true, onCallback: this.clear, titleText: titleText, clearText: clearText }),
                react_1.default.createElement("div", { className: "".concat(classPrefix, "__layout-container") },
                    react_1.default.createElement("div", { className: "intl__tree-content" },
                        react_1.default.createElement(TreeNode_1.default, { root: true, onCheck: this.onCheck, data: data, showText: showText, showLessText: showLessText, showListStatus: showListStatus }),
                        childLen ? (react_1.default.createElement("div", { className: "switch switch-count", onClick: function () {
                                _this.setState({
                                    showListStatus: !showListStatus,
                                });
                            } },
                            showListStatus ? showLessText : showText,
                            react_1.default.createElement(icon_1.default, { className: (0, classnames_1.default)('tree-svg', {
                                    'tree-svg-show': !showListStatus,
                                    'tree-svg-less': showListStatus,
                                }), name: "right-outlined", size: 18, color: '#006EFF' }))) : null)))));
    };
    return TreeOrigin;
}(react_1.default.Component));
exports.default = TreeOrigin;
TreeOrigin.contextType = config_provider_1.ConfigContext;
//# sourceMappingURL=TreeOrigin.js.map